import { apiBasePath } from '../BaseUrl';
import { apiUrl } from '../../../utils/api';

const extendedApi = apiBasePath.injectEndpoints({
    endpoints: (build) => ({
        // Get all credits
        getCredits: build.query({
            query: () => ({
                url: `${apiUrl.settings}credits/`,
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`
                }
            }),
            providesTags: ['Credits']
        }),

        // Get specific credit by feature code
        getCreditByFeatureCode: build.query({
            query: (featureCode) => ({
                url: `${apiUrl.settings}credits/${featureCode}/`,
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`
                }
            }),
            providesTags: (result, error, featureCode) => [{ type: 'Credits', id: featureCode }]
        }),
        getCreditSubFeature: build.query({
            query: ({ featureCode, subFeatureCode }) => ({
                url: `${apiUrl.settings}credits/${featureCode}/${subFeatureCode}/`,
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`
                }
            }),
            providesTags: (result, error, featureCode) => [{ type: 'Credits', id: featureCode }]
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetCreditsQuery,
    useGetCreditByFeatureCodeQuery,
    useGetCreditSubFeatureQuery,
} = extendedApi;
